import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthContext';

/** Gate for a permission-restricted route, nested inside `ProtectedRoute`.
 * Redirects to the dashboard rather than showing a 403 page — avoids
 * confirming to an unauthorized coach that the route exists at all. */
export function PermissionRoute({ permission }: { permission: string }): JSX.Element {
  const { hasPermission } = useAuth();
  if (!hasPermission(permission)) return <Navigate to="/" replace />;
  return <Outlet />;
}
